import className from "classnames/bind";

import styles from "./DigitalExhibitQuiz.module.scss";
const cx = className.bind(styles);

type QuizProgressProps = {
  label: string;
  pct: number;
  announce?: string;
};

export default function QuizProgress({ label, pct, announce }: QuizProgressProps) {
  return (
    <div className={cx("dx-quiz__progress")} data-quiz-stagger>
      <div className={cx("dx-quiz__progress-track")}>
        <div className={cx("dx-quiz__progress-fill")} style={{ width: `${pct}%` }} />
      </div>
      <span className={cx("dx-quiz__progress-count", "dx-body")}>{label}</span>
      {announce && (
        <span className="sr-only" aria-live="polite">
          {announce}
        </span>
      )}
    </div>
  );
}
